import { useCallback } from 'react';
import { useDispatch } from 'store/hooks';
import { blotterComponentsSetSelectedRowIdsAction } from './actions';

export const useDispatchBlotterComponentsSetSelectedRowIdsAction = () => {
    const dispatch = useDispatch();
    return useCallback((blotterId: string, selectedRowIds: number[]) => {
        dispatch(
            blotterComponentsSetSelectedRowIdsAction(blotterId, selectedRowIds)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
